import { useI18n } from '../../../shared/i18n/I18nProvider';
import { ReadOnlyModal } from '../../../shared/ui/WorkspaceKit';
import type { Employee } from '../api/staffApi';

export function StaffEditor({ onClose }: { item?: Employee; onClose: () => void; onDone: () => void }) {
  const { t } = useI18n();
  return <ReadOnlyModal feature={t('Cập nhật nhân viên')} onClose={onClose} />;
}
